import { TOURNAMENT_SELECTED, TOURNAMENT_FINISH, BUCKET_BASE_POINT, BUCKET_ADD_POINT, FINAL_TEAM_SCORE, GET_PLAYER_DISTANCE, PVE_GAME_PLAY, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    tournamentSelected: "",
    tournamentFinish: false,
    bucketBasePoint: false,
    bucketAddPoint: false,
    finalTeamScore: {},
    playerDistance: []
}

export const gameRobotReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOURNAMENT_SELECTED:
            return {
                ...state,
                tournamentSelected: action.payload
            };
        case TOURNAMENT_FINISH:
            console.log('TOURNAMENT_FINISH action received in reducer:', action.payload);
            return {
                ...state,
                tournamentFinish: action.payload
            }
        case BUCKET_BASE_POINT:
            return {
                ...state,
                bucketBasePoint: action.payload
            }
        case BUCKET_ADD_POINT:
            return {
                ...state,
                bucketAddPoint: action.payload
            }
        case FINAL_TEAM_SCORE:
            return {
                ...state,
                finalTeamScore: action.payload
            }
        case GET_PLAYER_DISTANCE:
            return {
                ...state,
                playerDistance: action.payload
            }
        case PVE_GAME_PLAY:
            return {
                ...state,
                pveGamePlay: action.payload
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}